const getEssentialExtrasData = (essentialExtras, matchingAccessoriesOptions) => {
  let extrasData = null
  if (
    essentialExtras?.data &&
    essentialExtras.data.id &&
    essentialExtras.data.name &&
    essentialExtras.data.price &&
    essentialExtras.data.variants &&
    matchingAccessoriesOptions
  ) {
    extrasData = {
      mainProduct: matchingAccessoriesOptions?.mainProduct,
      id: essentialExtras.data.id,
      name: essentialExtras.data.name,
      price: essentialExtras.data.price,
      variants: essentialExtras.data.variants,
      specialOfferPrice: essentialExtras.data.specialOfferPrice,
      specialOfferText: essentialExtras.data.specialOfferText
    }
  }
  return extrasData
}

export { getEssentialExtrasData }
